import { sendGAEvent } from "@next/third-parties/google";

export type EventParams = Record<string, string | number | boolean | undefined>;

const pathPrefix: { [path: string]: string } = {
  "^\/?$": "home_",
  "^\/request\/?$": "inquiry_",
  "^\/service\/?$": "service_",
  "^\/pricing\/?$": "pricing_",
  "^\/blog\/?$": "blog_",
  "^\/blog\/.*": "blog_post_",
};

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "0.0.0.0", "::1"]);

function isDeveloperTraffic() {
  if (process.env.NODE_ENV !== "production") return true;
  if (typeof window === "undefined") return false;
  const hostname = window.location.hostname;
  return LOCAL_HOSTS.has(hostname) || hostname.startsWith("192.168.") || hostname.startsWith("10.") || hostname.endsWith(".local");
}

function cleanEventParams(params?: EventParams) {
  return Object.fromEntries(
    Object.entries({
      ...(params ?? {}),
      ...(isDeveloperTraffic() ? { debug_mode: true, traffic_type: "developer" } : {}),
    }).filter(([, value]) => value !== undefined),
  );
}

/**
 * GA4 이벤트 전송
 */
export function trackEvent(eventName: string, path: string, params?: EventParams) {
  const prefixPattern = Object.keys(pathPrefix).find((pattern) => new RegExp(pattern).test(path));
  const prefix = prefixPattern ? pathPrefix[prefixPattern] : "";

  if (typeof window !== "undefined") {
    sendGAEvent("event", `${prefix}${eventName}`, cleanEventParams(params));
  }
}
